import React from "react";
import ProfileCard from "../components/profilecard";
import Repo from "../components/repo";
class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: props.profile,
      repos: props.repos
    };
  }

  render() {
    return (
      <div className="profile">
        <div className="row">
          <div className="col m4 sm12">
            <ProfileCard profile={this.state.profile} />
          </div>
          <div className="col s12 m8">
            <div className="repos">
              {this.state.repos.map(repo => (
                <Repo key={repo.id.toString()} data={repo} />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Profile;
